"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getMessageHeading = exports.formatEditGroup = exports.formatMessages = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var pluralize_1 = __importDefault(require("pluralize"));
var ui_common_1 = require("@codametrix/ui-common");
var EditorIssueProvenance = ui_common_1.commonEnums.EditorIssueProvenance, EditorIssueLevel = ui_common_1.commonEnums.EditorIssueLevel;
var formatMessage = function (messageType, idx) { return function (edit) {
    return ((0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)("span", { children: edit.message }) }, "".concat(edit.message, "-").concat(idx)));
}; };
var formatEditGroup = function (rawEdits, idx) {
    // Messages are grouped by two properties.
    // 1. the source of the messages : CCI or Claims
    // 2. the status level : Warning or Error
    // We first sort the messages by source, and then by level.
    var sourceGroups = ui_common_1.objectUtils.groupBy(rawEdits, 'source');
    return Object.values(sourceGroups).map(function (edits, subIdx) {
        var levelGroups = ui_common_1.objectUtils.groupBy(edits, 'level');
        return Object.values(levelGroups).map(function (levelGroup, sectionIdx) {
            var _a;
            var _b = __read(levelGroup, 1), edit = _b[0];
            var editLevel = ((_a = edit === null || edit === void 0 ? void 0 : edit.level) !== null && _a !== void 0 ? _a : 'unknown').toLowerCase();
            var heading = getMessageHeading(levelGroup);
            var formatEdit = formatMessage(editLevel, subIdx);
            var editMessages = levelGroup.map(formatEdit);
            var styleClasses = (0, classnames_1["default"])("".concat(editLevel, "-msg"));
            return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "messages" }, { children: [heading, (0, jsx_runtime_1.jsx)("ul", __assign({ className: styleClasses }, { children: editMessages }))] }), "".concat(idx, "-").concat(subIdx, "-").concat(sectionIdx)));
        });
    });
};
exports.formatEditGroup = formatEditGroup;
var formatMessages = function () {
    var _a;
    var issueGroups = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        issueGroups[_i] = arguments[_i];
    }
    if (!issueGroups || !issueGroups.length) {
        return false;
    }
    return (_a = issueGroups.map(formatEditGroup).flat()) !== null && _a !== void 0 ? _a : false;
};
exports.formatMessages = formatMessages;
var getMessageHeading = function (edits) {
    var _a = __read(edits, 1), edit = _a[0];
    var errorType = ui_common_1.objectUtils.capitalize("".concat(edit.level));
    var source = edit.source !== EditorIssueProvenance.CCI
        ? ui_common_1.objectUtils.capitalize("".concat(edit.source))
        : edit.source;
    return ((0, jsx_runtime_1.jsxs)("h5", __assign({ className: "message-type-heading qa-scrubber-message-heading" }, { children: [source, " ", (0, pluralize_1["default"])(errorType, edits.length)] })));
};
exports.getMessageHeading = getMessageHeading;
//# sourceMappingURL=editor-issues.js.map